export const SHOP_ROUTE_NAMES = {
  BRAND_DETAILS: 'brand-details',
  BRAND_MENU: 'brand-menu',
  CHOOSE_LICENSE: 'choose-license',
  DISCOVER_PRODUCTS: 'discover-products',
  EXPRESS_MENU: 'express-menu',
  PRODUCT_DETAILS: 'product-details',
  PUBLIC_MENU: 'public-menu',
  PURCHASE_HISTORY: 'purchase-history',
  PURCHASE_HISTORY_NEW: 'purchase-history-new',
  VENDOR_DETAILS: 'vendor-details',
  SHOP_BRAND_PREVIEW: 'shop-brand-preview',
  SHOP: 'shop',
  SHOP_BRANDS: 'shop-brands',
  SHOP_DEALS: 'shop-deals',
  SHOP_PRODUCTS: 'shop-products',
  STORE_FAVORITES: 'store-favorites',
  VENDOR_MENU: 'vendor-menu',
};
